'use client';

import React from 'react';
import map from 'lodash/map';
import { KibList, KibListIcon } from '@chewy/kib-lists-react';
import '@chewy/kib-lists-styles/dist/kib-lists.css';
import { KibSectionHeading } from '@chewy/kib-content-groups-react';
import '@chewy/kib-content-groups-styles/dist/styles/kib-section-heading.css';
import { getTopicIcon } from '@/utils/helpCenterUtils';
import styles from './linksPanel.module.scss';

export interface LinkData {
  id: string;
  title?: string;
  icon?: string;
  link?: string;
  categoryId?: string;
  sectionId?: string;
  sectionTitle?: string;
  sectionCategoryId?: string;
}

export interface LinksPanelProps {
  readonly title?: string | null;
  readonly linksData?: LinkData[] | null;
  readonly handleClick: (linkData: LinkData) => void;
}

const LinksPanel: React.FC<LinksPanelProps> = ({ title, handleClick, linksData = [] }) => {
  const sectionId = `links-section-${title ? title.toLowerCase().replace(/\s+/g, '-') : 'untitled'}`;

  return (
    <KibSectionHeading heading={title} className={styles.promoSection} aria-labelledby={sectionId} aria-label={title || undefined}>
      <KibList className={styles.promoLinks} role="list" aria-labelledby={sectionId}>
        {map(linksData, (linkData, index) => {
          return (
            <KibListIcon className={styles.promoLinkIcon} key={linkData.id || index} icon={getTopicIcon(linkData.icon)}>
              <a
                className={styles.link}
                href={linkData.link || `#${linkData.id || ''}`}
                onClick={e => {
                  e.preventDefault();
                  handleClick(linkData);
                }}
              >
                {linkData?.title}
              </a>
            </KibListIcon>
          );
        })}
      </KibList>
    </KibSectionHeading>
  );
};

export default LinksPanel;
